﻿import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectCondosAndTownHomes, selectProductAndResultType } from '../redux/selectors';
import getDefaultProductType from '../services/productTypeService';
import getDefaultResultType from '../services/resultTypeService';
import { searchParametersSlice } from '../redux/slices';

export default class CondoAndTownHomesHousingType {
  constructor() {
    this.selector = '[data-housing-type="condosAndTownHomes"]';
    store$
      .pipe(map(selectCondosAndTownHomes), distinctUntilChanged())
      .subscribe(this.onCondosAndTownHomesChange.bind(this));

    store$.pipe(map(selectProductAndResultType), distinctUntilChanged())
      .subscribe(this.onProductAndResultTypeChange.bind(this));
  }

  /**
   * The dispatchAction function dispatches a fetchCondosAndTownHomes action with the payload obtained from the
   * getSearchCommands function.
   */
  dispatchFetchResultAction() {
    const payload = this.getSearchCommands();
    store.dispatch(searchParametersSlice.actions.fetchCondosAndTownHomes(payload));
  }

  /**
   * Gets the node element of condo and townhomes box.
   * @returns {Node} element.
   */
  getNode() {
    return document.querySelector(this.selector);
  }

  /**
   * getSearchCommandProperty: Gets the search command property of this Housing Box.
   * @returns The search command property string.
   */
  getSearchCommands() {
    const searchCommandPropertyStructure = {
      productType: this.productTypeToApply,
      resultType: this.resultTypeToApply,
      condosAndTownHomes: this.condosAndTownHomesToApply,
    };

    return searchCommandPropertyStructure;
  }

  /**
   * The function updates the product and result type to apply based on the selected product and result type.
   * @param productAndResultType - It represents the object with the product and result type.
   */
  onProductAndResultTypeChange(productAndResultType) {
    const { resultType, productType} = productAndResultType;
    this.productTypeToApply = getDefaultProductType(productType, resultType);
    this.resultTypeToApply = getDefaultResultType(resultType);
  }

  onCondosAndTownHomesChange(condosAndTownHomes) {
    this.condosAndTownHomesToApply = !condosAndTownHomes;
    this.toggleBox(condosAndTownHomes);
  }

  toggleBox(condosAndTownHomes) {
    const node = this.getNode();
    if (condosAndTownHomes) {
      node.selected = true;
    } else {
      node.selected = false;
    }
  }
}
